import { heroStats } from "@/mocks/home";

const keywordChips = [
  "完整版",
  "未删减",
  "无删减版",
  "高清完整版",
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-100">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 -right-24 w-80 h-80 rounded-full bg-accent-200/40 blur-3xl"></div>
        <div className="absolute bottom-0 left-10 w-72 h-72 rounded-full bg-primary-100/50 blur-3xl"></div>
      </div>

      <div className="relative w-full max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-20 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
        <div className="w-full">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-900 text-xs md:text-sm font-medium">
            <i className="ri-information-line"></i>
            影视内容信息整理站
          </span>

          <h1 className="mt-5 font-heading text-3xl md:text-5xl font-semibold leading-tight text-foreground-950">
            姐姐的朋友电影
            <span className="block mt-2 text-primary-600">完整版 · 未删减 · 高清资源说明</span>
          </h1>

          <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-700 max-w-xl">
            想了解姐姐的朋友电影的完整版资源内容，可以从完整版、未删减、无删减版与完整资源开始。
            本站把这几类说法背后的含义、区别和判断方法整理在一页里，让你在查找之前先把方向弄清楚。
          </p>

          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <a
              href="#content"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-list-check-2"></i>
              完整版包含哪些内容
            </a>
            <a
              href="#versions"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50 text-foreground-800 text-sm font-medium border border-background-300 hover:border-secondary-400 hover:text-secondary-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-scales-3-line"></i>
              对比四种版本
            </a>
          </div>

          <div className="mt-9 grid grid-cols-3 gap-4 max-w-md">
            {heroStats.map((stat) => (
              <div key={stat.id} className="border-l-2 border-accent-400 pl-3">
                <div className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
                  {stat.value}
                </div>
                <div className="mt-1 text-xs md:text-sm text-foreground-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="w-full relative">
          <div className="relative w-full max-w-sm mx-auto">
            <div className="w-full aspect-[3/4] rounded-lg overflow-hidden border border-background-300 bg-background-50">
              <img
                src="https://readdy.ai/api/search-image?query=stylized%20cinematic%20vertical%20movie%20poster%20background%20with%20warm%20crimson%20and%20golden%20gradient%20light%2C%20abstract%20camera%20aperture%20and%20film%20strip%20motifs%2C%20delicate%20film%20grain%20texture%2C%20elegant%20moody%20atmosphere%2C%20no%20text%2C%20editorial%20art%20style%2C%20rich%20warm%20tones%2C%20high%20detail&width=800&height=1200&seq=sister-friend-cover-01&orientation=portrait"
                alt="姐姐的朋友电影封面风格的主视觉，暖色调的影像质感"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="absolute -bottom-6 -left-4 md:-left-8 w-[78%] rounded-lg bg-background-50 border border-background-200 p-4">
              <div className="text-xs font-medium text-foreground-500">常见检索方向</div>
              <div className="mt-2 flex flex-wrap gap-1.5">
                {keywordChips.map((chip) => (
                  <span
                    key={chip}
                    className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs"
                  >
                    {chip}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}